import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";

const NewLastName = () => {
  const {

    newLastName,
    setNewLastName,
    newLastNameValidity,
    setNewLastNameValidity,
    newLastNameChecked,
    setNewLastNameChecked,
    typeNewLastNameData,
    setTypeNewLastNameData,

    fullName, setFullName,

  } = useAppContext() as AppContextType;

  const handleBlur = () => {
    setNewLastNameChecked(true);
    setNewLastNameValidity(newLastName.trim() !== "");
  };

  return (
    <div className="card-body">
      <div className="mb-3">
        <label htmlFor="affectedIndividuals" className="form-label">
          Type de modification
        </label>
        <select
          className="form-select"
          id="affectedIndividuals"
          onChange={(e) => {
            setNewLastName("");
            setNewLastNameChecked(false);
            setNewLastNameValidity(true);
            setTypeNewLastNameData(Number(e.target.value));
          }}
          value={typeNewLastNameData}
        >
          <option value={0}>Remplacement du nom actuel</option>
          <option value={1}>Ajout au nom actuel</option>
        </select>
      </div>

      {
        typeNewLastNameData === 0 && (
          <div className="mb-3">
            <label htmlFor="newLastName" className="form-label">
              Nouveau nom <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="newLastName"
              placeholder="Entrez le nouveau nom"
              className={`form-control ${!newLastNameValidity && newLastNameChecked ? "is-invalid" : ""}`}
              value={newLastName}
              onChange={(e) => setNewLastName(e.target.value)}
              onBlur={handleBlur}
            />
            {!newLastNameValidity && newLastNameChecked && (
              <div className="invalid-feedback">
                Ce champ est obligatoire.
              </div>
            )}
          </div>
      )}

      {typeNewLastNameData === 1 && (
        <div>
          <div className="mb-3">
            <label htmlFor="nameToAdd" className="form-label">
              Nom à ajouter
            </label>
            <input
              type="text"
              id="nameToAdd"
              placeholder="Entrez le nom à ajouter"
              className="form-control"
              value={fullName.additionalName}
              onChange={(e) => setFullName({ ...fullName, additionalName: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="fullName" className="form-label">
              Nom complet
            </label>
            <input
              type="text"
              id="fullName"
              placeholder="Entrez le nom complet"
              className="form-control"
              value={fullName.fullName}
              onChange={(e) => setFullName({ ...fullName, fullName: e.target.value })}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NewLastName;
